function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import { studyVisaTitle } from "../Common/Constants";
export var GetVisaTitleByMarketId = function GetVisaTitleByMarketId(data, id) {
  return data.find(function (d) {
    return d.id === id;
  })[studyVisaTitle];
};
export var GetDegreeOptionsByEducationLevel = function GetDegreeOptionsByEducationLevel(levels, educationLevel) {
  var _levels$filter;
  return levels === null || levels === void 0 ? void 0 : (_levels$filter = levels.filter(function (e) {
    return e.name === educationLevel;
  })) === null || _levels$filter === void 0 ? void 0 : _levels$filter.map(function (e) {
    return e.options;
  })[0];
};
export function getDisciplinesForSearchParamsMapping(fields, fieldsOfEducation) {
  if (fields.length === 0 || fieldsOfEducation.length === 0) return [];
  return fieldsOfEducation.filter(function (field) {
    return fields.includes(field.name);
  }).reduce(function (acc, field) {
    var _field$children$filte, _field$children;
    // find only the field.children that also exist in fields
    var matchingChildren = (_field$children$filte = (_field$children = field.children) === null || _field$children === void 0 ? void 0 : _field$children.filter(function (child) {
      return fields.includes(child.name);
    })) !== null && _field$children$filte !== void 0 ? _field$children$filte : [];
    if (matchingChildren.length > 0) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(matchingChildren.map(function (child) {
        return "".concat(field.name, ":").concat(child.name);
      })));
    } else {
      return [].concat(_toConsumableArray(acc), [field.name]);
    }
  }, []);
}